module.exports = __webpack_public_path__ + "imgs/shop.da495484d9ba3fe5a27e3f37bc2515e2.svg";